import { format } from 'date-fns';

import { DateFormat } from '@app/constants';
import { parseDateToUtc } from '@app/utils';

export const getInvoicePDFUrl = (date?: string | null): string | null =>
  date ? format(parseDateToUtc(date), DateFormat.YEAR_MONTH_DAY) : null;
